export { default } from './LegalPage';
export * from './types';
